<template>
  <div id="app" :class="{ greyWeb: grey }">
    <el-container :class="lang == 'en' ? 'en' : ''">
      <el-header v-show="lang == 'zh'">
        <AppHeader />
      </el-header>
      <el-header v-show="lang == 'en'">
        <AppHeaderEn />
      </el-header>
      <section class="main">
        <fade-transition origin="center" mode="out-in" :duration="250">
          <router-view />
        </fade-transition>
      </section>
      <el-footer><AppFooter :lang="lang" /></el-footer>
    </el-container>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import AppHeaderEn from "./layout/AppHeaderEn";
import cookie from "cookiejs";
import { isCN } from "@/utils/tool";

export default {
  data() {
    return {
      // lang: "zh",
      lang: this.$global.lang,
      grey: false,
    };
  },
  components: {
    FadeTransition,
    AppHeader,
    AppFooter,
    AppHeaderEn,
  },
  created() {
    if (!cookie.get("lang")) {
      if (!isCN()) {
        cookie("lang", "en");
        this.lang = "en";
      } else {
        cookie("lang", "zh");
        this.lang = "zh";
      }
    }
    /* this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        console.log('window.location.pathname',window.location)
        if(window.location.hash==='#/'){
        this.grey = true
          }else{
          this.grey = false
    }
      }
    ); */

    
  },
  mounted() {
    window.addEventListener('resize', this.reloadPage);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reloadPage);
  },
  methods:{
    reloadPage() {
      location.reload();
    }
  }
};
</script>

<style lang="scss">
.greyWeb {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}
</style>
